import {FactoryProvider, ModuleWithProviders, NgModule, Type} from '@angular/core';
import {BotatoChatStorageService} from './service/botato-chat-storage.service';
import {BotatoChatManagerService} from './service/botato-chat-manager.service';
import {Ng2DeviceService} from './device-detector/ng2-device.service';
import {DialogViewModelCreatorService} from './service/dialog-view-model-creator.service';
import {BotatoWidgetManagerService} from './service/botato-widget-manager.service';
import {BotatoAccessorService} from './service/botato-accessor.service';
import {BotatoChatLocalCommunicationService} from './service/botato-chat-local-communication.service';
import {CommunicationService} from './service/communication.service';
import {BotatoAngularLibBaseModule} from './botato-angular-lib-base.module';
import {BotatoChatComponent} from './botato-chat/botato-chat.component';
import {BotatoWidgetComponent} from './botato-widget/botato-widget.component';
import {BotatoChatLocalHandlerService} from './service/botato-chat-local-handler.service';
import {BotatoChatMessageResolverService} from './botato-chat-message/botato-chat-message-resolver.service';
import {DialogConfigProviderService} from './service/dialog-config-provider.service';
import {BotatoLocalConfig} from './botato-local.config';
import {BotatoChatInputResolverService} from './botato-chat-input/botato-chat-input-resolver.service';
import {InputDataService} from './botato-chat-input/input-data.service';
import {BotatoChatLocalContextProviderService} from './service/botato-chat-local-context-provider.service';

@NgModule({
    imports: [
        BotatoAngularLibBaseModule
    ],
    exports: [BotatoChatComponent, BotatoWidgetComponent]

})
export class BotatoAngularLibLocalModule {

    // DO NOT REMOVE: Service must be instantiated when app starts
    // eslint-disable-next-line
    constructor(botatoAccessorService: BotatoAccessorService) {
    }

    public static with(storageService: Type<BotatoChatStorageService>,
                       config: () => BotatoLocalConfig,
                       localHandlerService: Type<BotatoChatLocalHandlerService>,
                       inputDataService: Type<InputDataService> = InputDataService,
                       chatMessageResolverService: Type<BotatoChatMessageResolverService> = BotatoChatMessageResolverService,
                       chatInputResolverService: Type<BotatoChatInputResolverService> = BotatoChatInputResolverService): ModuleWithProviders<BotatoAngularLibLocalModule> {
        return {
            ngModule: BotatoAngularLibLocalModule,
            providers: [
                DialogConfigProviderService,
                BotatoChatManagerService,
                BotatoWidgetManagerService,
                Ng2DeviceService,
                DialogViewModelCreatorService,
                BotatoChatLocalContextProviderService,
                {provide: BotatoChatInputResolverService, useClass: chatInputResolverService},
                {provide: BotatoChatMessageResolverService, useClass: chatMessageResolverService},
                {provide: CommunicationService, useClass: BotatoChatLocalCommunicationService},
                {provide: BotatoChatStorageService, useClass: storageService},
                {provide: 'BOTATO_CONFIG', useFactory: config} as FactoryProvider,
                {provide: BotatoChatLocalHandlerService, useClass: localHandlerService},
                {provide: InputDataService, useClass: inputDataService}
            ]
        };
    }
}


